import React from 'react';
import { FaPhone } from 'react-icons/fa';

export default class ServicesTelsent extends React.Component {
  state = {
    isMounted: false,
  };

  componentDidMount() {
    setTimeout(
      function () {
        this.setState((prevState) => ({ isMounted: !prevState.isMounted }));
      }.bind(this),
      0
    );
  }

  render() {
    return (
      <div className="services-wrapper">
        <div className="scroll-downs">
          <div className="mousey">
            <div className="scroller"></div>
          </div>
        </div>
        {/* mobile and tablet */}
        <h2 className="services-title">Služby</h2>
        <div className="stolek-container" id="services"></div>
        <div className="services-grid">
          <div className="services-text-container desktop">
            <p
              className={
                this.state.isMounted ? 'services-text' : 'services-text'
              }
            >
              Naše firma se zabývá zakázkovou výrobou nábytku. Většinou se jedná
              o kompletní vybavení kuchyní nebo pokojů. Jednotlivé kusy jako
              skříně, stoly, židle, nebo i větší projekty jako je stůl recepce,
              nebo nábytek restaurace také není problém. Po konzultaci v našich
              prostorách spolu určitě něco vymyslíme.
              <br></br>
              <span>Stavte se na kafe!</span>
            </p>
          </div>
          {/* zrcadlo */}
          <div className="picture-container"></div>
        </div>

        <div className="ste konzultace">
          <h3 className="services-subtitle">Konzultace a návrh</h3>
          <p className="services-text">
            Společně zjistíme, jaký máme cíl a zpracujeme návrh. Ten později
            převedeme do vizualizace, kde jej doladíme do dokonalosti.
          </p>
        </div>

        {/* stolek */}
        <div className="hala-container"></div>

        <div className="ste notdesktop">
          <h3 className="services-subtitle">Výroba a montáž</h3>
          <p className="services-text">
            Vše v našich prostorách vyrobíme a u vás jen odborně namontujeme. Na
            naše výrobky poskytujeme <span>záruku x let</span>.
          </p>
        </div>
        <div className="hala2-container tablet notdesktop"></div>

        {/* konec mobile a tablet */}

        <div className="services-grid2" id="cislo">
          <div className="hala2-container desktop" id="services"></div>

          <div className="ste">
            <h3 className="services-subtitle">Výroba a montáž</h3>
            <p className="services-text">
              Vše v našich prostorách vyrobíme a u vás jen odborně namontujeme.
              Na naše výrobky poskytujeme <span>záruku x let</span>.
            </p>
          </div>
          <div className="hala2-container tablet"></div>

          <div className="background">
            <div className="call-container">
              <div className="call-title-container">
                <h2 className="call-title">Zavoláme Vám!</h2>

                <FaPhone className="FaPhone" />
              </div>
              <p className="mailsent-msg">Ozveme se Vám co nejdříve!</p>
              <form
                className="call-input-container hidden"
                action="getmail.php"
                method="post"
              >
                <div className="call-inputt">
                  <input
                    className="call-input"
                    type="number"
                    name="tel"
                    placeholder="Vaše tel. číslo"
                  ></input>
                </div>
                <div className="call-btnn">
                  <button className="call-btn" name="submit" type="submit">
                    Odeslat
                  </button>
                </div>
              </form>
              <p className="call-contact">Dušan Baťka — 777 338 077</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ServicesTelsent.js